"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertChainCode = assertChainCode;
exports.assertPrivateKey = assertPrivateKey;
exports.assertPublicKey = assertPublicKey;
var _base = require("@ckb-lumos/base");
const {
  assertHexString
} = _base.utils;
function assertPublicKey(publicKey, debugPath) {
  debugPath = debugPath || "publicKey";
  assertHexString(debugPath, publicKey);
  if (publicKey.length !== 68) {
    throw new Error(`publicKey must be length of 33 bytes!`);
  }
}
function assertPrivateKey(privateKey) {
  assertHexString("privateKey", privateKey);
  if (privateKey.length !== 66) {
    throw new Error(`privateKey must be length of 32 bytes!`);
  }
}
function assertChainCode(chainCode) {
  assertHexString("chainCode", chainCode);
  if (chainCode.length !== 66) {
    throw new Error(`chainCode must be length of 32 bytes!`);
  }
}
//# sourceMappingURL=helper.js.map